import Button from "common/commonButton";
import StatusChip from "components/bookings/History/status";
import { FC } from "react";
import { useNavigate } from "react-router-dom";
import { Icons } from "utils/iconPath";
import "./style.css";

type HeaderProps = {
  isBack?: boolean;
  Heading?: string;
  count?: number;
  ButtonTitle?: string;
  buttonOnClick?: () => void;
  buttonIsLoading?: boolean;
  isButton?: boolean;
  extraButton?: boolean;
  extraButtonIcon?: React.ReactNode;
  extraButtonIconPath?: string;
  rightChildren?: React.ReactNode;
  id?: string | number;
  status?: string;
  headerHeadingContainerStyle?: React.CSSProperties;
  isShareIcon?: boolean;
  shareIconClick?: () => void;
};

const Header: FC<HeaderProps> = ({
  isBack,
  Heading,
  count,
  ButtonTitle,
  buttonOnClick,
  buttonIsLoading,
  isButton,
  extraButton,
  extraButtonIcon,
  extraButtonIconPath,
  rightChildren,
  id,
  status,
  headerHeadingContainerStyle,
  isShareIcon,
  shareIconClick,
}) => {
  // hooks
  const navigate = useNavigate();

  // functions
  const handleBackButton = () => {
    navigate(-1);
  };

  return (
    <div className="headerContainer">
      {isBack && (
        <div className="headerBackButton" onClick={handleBackButton}>
          <img
            src={Icons.BACK_ICON_BLUE}
            alt="backButton"
            className="headerBackIcon"
          />
        </div>
      )}
      <div className="headerRightContainer">
        <div className="headerBackButtonAndHeading">
          <div
            className="headerHeadingContainer"
            style={{
              ...headerHeadingContainerStyle,
            }}
          >
            <h2 className="heading2">
              {Heading ? Heading + "" : ""}
              {id ? id : ""}
            </h2>
            {count && <h2 className="heading2">({count ?? ""})</h2>}
            {status && <StatusChip status={status} />}
          </div>
          {isShareIcon && (
            <div className="shareIconContainer" onClick={shareIconClick}>
              <img src={Icons.SHARE} alt="share icon" />
            </div>
          )}
        </div>
        <div className="headerRightButton">
          {isButton && (
            <Button
              variant={"primary"}
              title={ButtonTitle as string}
              onClick={buttonOnClick}
              isLoading={buttonIsLoading}
              containerStyle={{
                color: buttonIsLoading ? "#e23744" : "white",
              }}
            />
          )}
          {/* {extraButton && (
            <TertiaryButton
              title={ButtonTitle}
              onClick={buttonOnClick}
              isLoading={buttonIsLoading}
              startIcon={extraButtonIcon}
              iconPath={extraButtonIconPath}
            />
          )} */}
          {rightChildren && (
            <div className="rightChildren">{rightChildren}</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Header;
